import { _lang, lang, dupLang, getCurrentLang, isLang } from '@umu/ukit-lang';
import React from 'react';
import { IEditionItem, IPlanInfo, IUserInfo } from '@umu/umu-types';
import { If, PreImg } from 'common/src/components';
import { professionalEdition } from '../../../utils/util';
import { ProfessionalBuyButton } from '../../buyButton';
import { HideInApp } from '../../hideInApp';
const localeLang = getCurrentLang();
const closeImg = require(`../../../images/close.png`);
import { numToThousands } from 'utils/util';

interface IVersionItemProps {
    isRegisterUser: boolean;
    planInfo: IPlanInfo;
    siteHost: string;
    platform: 'twww' | 'mobile';
    userInfo?: IUserInfo;
    professionalPricing?: { amount_settle?: number; amount: number };
    setShowProFessional(flag: boolean): void;
    getList(list: IEditionItem[]): JSX.Element[];
}

export const ProFessionalCO = (props: IVersionItemProps) => {
    const { platform, setShowProFessional, getList, professionalPricing = { amount: 0 } } = props;
    const professionalEditionList = professionalEdition;

    const premiumPrice = professionalPricing.amount || professionalPricing.amount_settle || 99900;
    const premiumPriceFormat = numToThousands(premiumPrice);

    const isPc = platform === 'twww';
    return (
        <div className={isPc ? 'version-item' : 'version-item version-m-item'}>
            <div className="version-item-title">
                <span
                    dangerouslySetInnerHTML={{
                        __html: dupLang('专业版', 'src/plan/@planPricingCommon/components/@pricingVersion'),
                    }}
                ></span>
                <If condition={!isPc}>
                    <div
                        className="close-wraper"
                        onClick={() => {
                            setShowProFessional(false);
                        }}
                    >
                        <PreImg>
                            <img className="close-version" src={closeImg} alt="" />
                        </PreImg>
                    </div>
                </If>
            </div>
            <div className="version-item-des des-top">{lang('适用于个人培训师')}</div>
            <div className="version-item-price">
                <HideInApp>
                    <div className="price-des">
                        <div className="unit-price-wrapper">
                            <div className="unit-price-number">{numToThousands(premiumPrice / 12)}</div>
                            <div className="unit-price-text">
                                円
                                <If condition={localeLang === 'jp'}>
                                    <div className="unit-price-tax">（税込）</div>
                                </If>
                            </div>
                        </div>
                        <If condition={localeLang === 'jp'}>
                            <div className="jp-des">月額換算</div>
                        </If>
                        <If condition={localeLang === 'en'}>
                            <div className="jp-des">（tax included）/account</div>
                        </If>
                        <div className="unit-price-des">{lang('年額{$0}円／年払いのみ', premiumPriceFormat)}</div>
                    </div>
                </HideInApp>
                <ProfessionalBuyButton {...props} />
            </div>
            <div className="version-item-content">
                <div
                    className="content-title"
                    dangerouslySetInnerHTML={{
                        __html: isLang('jp')
                            ? 'ベーシックプランに加えて<br>以下プレミア機能をサポート：'
                            : lang('ベーシックプランに加えて以下プレミア機能をサポート：'),
                    }}
                ></div>
                <div className="content-list">{getList(professionalEditionList)}</div>
            </div>
        </div>
    );
};
